import React from "react";
import { Box, Button, ButtonBase, Typography } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import InsightsIcon from "@mui/icons-material/Insights";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";

const data = [
  {
    id: "1",
    title: "Become a Driver",
    desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    icon: <LocalShippingIcon sx={{ color: "#2B817B" }} />,
  },
  {
    id: "2",
    title: "Receive delivery request",
    desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    icon: <MenuBookIcon sx={{ color: "#2B817B" }} />,
  },
  {
    id: "3",
    title: "Track delivery distance",
    desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    icon: <InsightsIcon sx={{ color: "#2B817B" }} />,
  },
  {
    id: "4",
    title: "Earn money",
    desp: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    icon: <RequestQuoteIcon sx={{ color: "#2B817B" }} />,
  },
];

const data2 = [
  {
    id: "1",
    title:
      "What does delivering using EatCoast offer that traditional delivery driver jobs don’t ?",
    desp: "Different delivery driver jobs offer different opportunities. Not all food delivery drivers are able to work flexible hours whenever they choose. You can decide whether you want a traditional full-time orpart-time delivery driver or courer job, or whether you want to be an independent contractor doing app-based delivery shenever and whenever you want-or even do both.",
  },
  {
    id: "2",
    title: "Is the EatCoast platform safe ?",
    desp: "Different delivery driver jobs offer different opportunities. Not all food delivery drivers are able to work flexible hours whenever they choose. You can decide whether you want a traditional full-time orpart-time delivery driver or courer job, or whether you want to be an independent contractor doing app-based delivery shenever and whenever you want-or even do both.",
  },
  {
    id: "3",
    title: "What are the requirements to be a delivery driver with EatCoast ?",
    desp: "Different delivery driver jobs offer different opportunities. Not all food delivery drivers are able to work flexible hours whenever they choose. You can decide whether you want a traditional full-time orpart-time delivery driver or courer job, or whether you want to be an independent contractor doing app-based delivery shenever and whenever you want-or even do both.",
  },
  {
    id: "4",
    title: "How often would i have to deliver with EatCoast ?",
    desp: "Different delivery driver jobs offer different opportunities. Not all food delivery drivers are able to work flexible hours whenever they choose. You can decide whether you want a traditional full-time orpart-time delivery driver or courer job, or whether you want to be an independent contractor doing app-based delivery shenever and whenever you want-or even do both.",
  },
];

const FoodDelivery = () => {
  return (
    <Box sx={{ mt: "70px" }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { lg: "row", md: "row", sm: "row", xs: "column" },
          justifyContent: "center",
          // border:"1px solid red"
        }}
      >
        <Box sx={{ width: { lg: "50%", md: "50%", sm: "50%", xs: "100%" } }}>
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "35px",
              }}
            >
              How food delivery driving works ?
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "13px",
                color: "#545359",
              }}
            >
              If you’re new to earning with EatCoast, and fill you personal
              data. Once you’re notified that you are active, you begin to
              receive delivery requests. The Driver app offers resources and
              will help you learn as you go
            </Typography>
          </Box>
          <Box sx={{ mt: "40px" }}>
            <Button variant="contained">Order Now</Button>
          </Box>
        </Box>
        <Box sx={{ mt: { lg: "0px", md: "0px", sm: "0px", xs: "20px" } }}>
          {data &&
            data.map((val, ind) => {
              return (
                <>
                  <Box
                    sx={{
                      width: "300px",
                      height: "100px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      mb: "10px",
                    }}
                  >
                    <Box
                      sx={{
                        width: "80px",
                        height: "40px",
                        border: "1px solid #E1E1E6",
                        borderRadius: "50%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {val.icon}
                    </Box>
                    <Box sx={{ ml: "20px" }}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "20px",
                        }}
                      >
                        {val.title}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "#545359",
                        }}
                      >
                        {val.desp}
                      </Typography>
                    </Box>
                  </Box>
                </>
              );
            })}
        </Box>
      </Box>
      <Box sx={{ mt: "50px", mb: "60px", px: { lg: 8, md: 7, sm: 3, xs: 3 } }}>
        {data2 &&
          data2.map((v, i) => {
            return (
              <>
                <Accordion sx={{ backgroundColor: "#F6F6F6", mb: "20px" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#2B817B" }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>{v.title}</Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ backgroundColor: "white" }}>
                    <Typography>{v.desp}</Typography>
                  </AccordionDetails>
                </Accordion>
              </>
            );
          })}
      </Box>
    </Box>
  );
};

export default FoodDelivery;
